import { Design } from '@thive/fddm-types';

import { templatesToFlatCollection } from '@/modules/floorplanDesign/helpers/helpers';

/**
 * @description The group id of a regenerated template: TPS can give it a new id, so select this one
 * afterwards. Undefined when the regeneration failed.
 */
export const getRegeneratedTemplateId = (
  regeneration: { result: 'success'; data: Design } | { result: 'failed' },
): string | undefined =>
  regeneration.result === 'success'
    ? templatesToFlatCollection(regeneration.data.templates)[0]?.group.id
    : undefined;
